/**
 * Sổ ghi "đang có lượt bói chỉ tay chạy nền", để báo được ở BẤT KỲ trang nào.
 *
 * Vì sao cần: từ v92 người xem được mời rời trang trong lúc chờ. Nhưng khi họ đã sang
 * Tử Vi hay Kinh Dịch thì trang chỉ tay đã unmount — không còn ai poll, không còn ai
 * biết lượt ấy xong lúc nào. Push về device chỉ tới được khi họ đã RỜI HẲN app (và
 * còn phải cấp quyền thông báo); người đang mở app ở tab khác thì không nhận gì.
 *
 * Nên id lượt đang chạy được ghi vào localStorage, và `PalmJobWatcher` (mount ở
 * `__root`) đọc sổ này để theo dõi hộ — đúng cách `CheckinButton` nhớ "đã nhắc điểm
 * danh hôm nay" bằng localStorage.
 *
 * ⚠️ Chỉ theo dõi MỘT lượt: BE khoá một việc trên một bản nháp, và người xem cũng
 * chỉ làm một lượt tại một thời điểm. Ghi lượt mới là thay lượt cũ.
 */

const KEY = "palm_job_watch";

/** Bắn khi sổ đổi, để watcher trong CÙNG tab biết ngay (`storage` chỉ bắn sang tab khác). */
export const PALM_JOB_EVENT = "palm-job-watch";

/**
 * Quá hạn này thì bỏ im lặng, không báo.
 *
 * Người xem đóng máy rồi mở lại sau hai tiếng mà bị toast "bài luận đã xong" thì đó
 * là tin cũ chứ không phải thông báo — và bài luận vẫn nằm nguyên trong lịch sử của
 * họ, không mất đi đâu.
 */
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export type WatchedPalmJob = {
  draftId: string;
  stage: "scan" | "reading";
  /** `Date.now()` lúc giao việc. */
  startedAt: number;
};

function emit(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(PALM_JOB_EVENT));
}

export function rememberPalmJob(draftId: string, stage: "scan" | "reading"): void {
  if (typeof window === "undefined" || !draftId) return;
  try {
    const entry: WatchedPalmJob = { draftId, stage, startedAt: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(entry));
    emit();
  } catch {
    // localStorage đầy hoặc bị chặn (chế độ riêng tư). Mất thông báo là chuyện nhỏ;
    // ném lỗi ở đây là làm gãy đúng cái call vừa giao việc thành công.
  }
}

export function readPalmJob(): WatchedPalmJob | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const entry = JSON.parse(raw) as WatchedPalmJob;
    if (!entry?.draftId || typeof entry.startedAt !== "number") return null;
    if (Date.now() - entry.startedAt > MAX_AGE_MS) {
      forgetPalmJob();
      return null;
    }
    return entry;
  } catch {
    return null;
  }
}

export function forgetPalmJob(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(KEY);
    emit();
  } catch {
    /* xem `rememberPalmJob` */
  }
}
